/* eslint-disable */
import { produce } from "immer";
import {
  TAX_FREE_CREATE_FETCH_START,
  TAX_FREE_CREATE_FETCH_SUCCESS,
  TAX_FREE_CREATE_FETCH_FAILURE,
} from "../actions/types";

const taxFreeIncomeCreateReducer = (
  state = {
    taxFreeIncomeFetching: false,
    taxFreeIncomeData: [],
    taxFreeIncomeError: null,
  },
  action,
) => {
  switch (action.type) {
    case TAX_FREE_CREATE_FETCH_START:
      return produce(state, (draft) => {
        draft.taxFreeIncomeFetching = true;
      });
    case TAX_FREE_CREATE_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.taxFreeIncomeFetching = true;
        draft.taxFreeIncomeData = action.data;
        draft.taxFreeIncomeFetching = false;
      });
    case TAX_FREE_CREATE_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.taxFreeIncomeFetching = false;
        draft.taxFreeIncomeError = action.error;
      });
    default:
      return state;
  }
};

export default taxFreeIncomeCreateReducer;
